<template>
  <v-dialog v-model="dialog" scrollable>
    <v-card>
      <v-card-title>
        スタッフ情報編集
        <v-spacer />
        <IconButton icon="mdi-close" @click="cancel" />
      </v-card-title>

      <v-card-text style="max-height: 750px">
        <v-card-actions v-show="editFlg">
          <v-list-item class="grow">
            <Avatar
              v-if="this.userAvater"
              :src="this.userAvater"
              :size="40"
              class="mr-2"
            />

            <v-list-item-content>
              <v-list-item-title>{{ this.userName }}</v-list-item-title>
              <v-list-item-subtitle>{{
                this.positionName.label
              }}</v-list-item-subtitle>
            </v-list-item-content>
            <Button @click="login_confirm" color="primary">代理ログイン</Button>
          </v-list-item>
        </v-card-actions>

        <v-row v-if="loading"
          ><v-col><Loader :loading="loading" /></v-col
        ></v-row>

        <v-form ref="staff_form">
          <v-container>
            <v-row>
              <v-col cols="6">
                <FormInputComponent
                  label="姓"
                  type="string"
                  v-model="userFamilyName"
                  rules="required"
                  :counter="10"
                />
              </v-col>

              <v-col cols="6">
                <FormInputComponent
                  label="名"
                  type="string"
                  v-model="userFirstName"
                  rules="required"
                  :counter="10"
                />
              </v-col>

              <v-col cols="6">
                <FormInputComponent
                  label="姓ふりがな"
                  type="string"
                  v-model="userFamilyNameFurigana"
                  rules="required"
                  :counter="10"
                />
              </v-col>

              <v-col cols="6">
                <FormInputComponent
                  label="名ふりがな"
                  type="string"
                  v-model="userFirstNameFurigana"
                  rules="required"
                  :counter="10"
                />
              </v-col>

              <v-col cols="12">
                <FormInputComponent
                  label="パスワード"
                  v-model="entryPassword"
                  rules="passwordRules"
                  :counter="8"
                  type="password"
                />
              </v-col>

              <v-col cols="12">
                <FormInputComponent
                  label="パスワード再"
                  v-model="entryPasswordRetry"
                  rules="passwordRules"
                  :counter="8"
                  type="password"
                />
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <FormInputComponent
                  label="メールアドレス(ログイン名)"
                  v-model="loginId"
                  rules="loginIdRules"
                  :counter="256"
                  type="string"
                />
              </v-col>

              <v-col cols="12">
                <DatePicker
                  v-model="startWorkingAt"
                  label="勤務開始日"
                  type="month"
                />
              </v-col>

              <v-col cols="12">
                <DatePicker v-model="endWorkingAt" label="勤務終了日" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  label="優先順位"
                  v-bind:disabled="isJinji"
                  v-model="userRank"
                  item-text="label"
                  item-value="value"
                  :items="userRankItems"
                  :rules="userRankRules"
                  @input="afterselection"
                  return-object
                />
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-select
                  label="部署"
                  v-model="departmentName"
                  item-text="label"
                  item-value="value"
                  :items="departmentItems"
                  return-object
                />
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-select
                  label="役職"
                  v-model="positionName"
                  item-text="label"
                  item-value="value"
                  :items="positionItems"
                  :rules="positionNameRules"
                  return-object
                />
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-file-input
                  v-model="input_image"
                  accept=".jpg,.jpeg,.png,"
                  label="スタッフ様のイメージ画像を選択してください。"
                  prepend-icon="mdi-image"
                  @change="onImageChange"
                ></v-file-input>
                <div
                  class="text-center"
                  style="padding-left: 17px; padding-right: 17px"
                >
                  <img v-if="uploadImageUrl" :src="uploadImageUrl" id="MyImg" />
                </div>
              </v-col>
              <v-col cols="6" md="4" lg="2">
                <Button @click="erntry_confirm" color="primary">登録</Button>
              </v-col>
              <v-col v-if="!entryFlg" cols="6" md="4" lg="2">
                <Button @click="delete_confirm" color="danger">削除</Button>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <v-row v-if="loading"
          ><v-col><Loader :loading="loading" /></v-col
        ></v-row>

        <ConfirmDialog
          ref="confirm"
          title="スタッフ情報編集"
          :message="confirmMessage"
          buttonMessage="OK"
          @confirm="editStaffInfo"
        >
        </ConfirmDialog>

        <DialogMessage ref="dialog" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import config from '../../../const.js';
import message from '../../../message.js';
import moment from 'moment';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import {
  encrypt256,
  setSessionStorageItem,
  getSessionStorageItem,
  makeDateFormatStr,
  makeDateTimeStr,
  imageToBase64,
  chackDateFormatStr,
  makeLoginId,
} from '../../../common.js';
export default {
  components: {
    ConfirmDialog,
  },
  data: () => ({
    dialog: false,
    confirm: false,
    entryFlg: false,
    editFlg: false,
    deleteFlg: false,
    loginFlg: false,
    resolve: null,
    reject: null,
    isJinji: false,

    loading: false,
    input_image: null,
    uploadImageUrl: '',
    avater: '',
    confirmMessage: null,

    userId: null,
    loginId: null,
    password: null,
    entryPassword: '',
    entryPasswordRetry: '',
    organaizationKey: null,
    userFamilyName: null,
    userFamilyNameFurigana: null,
    userFirstName: null,
    userFirstNameFurigana: null,
    userName: null,
    userNameFurigana: null,
    userRank: { label: '', value: '' },
    userRankRules: [(v) => !!v || '必須選択入力項目です'],
    departmentKey: null,
    departmentName: { value: '', label: '' },
    positionId: null,
    positionName: { value: '', label: '' },
    positionNameRules: [(v) => !!v || '必須選択入力項目です'],
    showTitle: null,
    userAvater: '',
    userAvaterUseEntry: '',
    startWorkingAt: null,
    startWorkingAtEntry: null,
    endWorkingAt: null,
    endWorkingAtEntry: null,
    expiration: null,
    createdAt: null,
    updateAt: null,
    userRankItems: [],
    departmentItems: [],
    positionItems: [],
    items: [],
    options: {
      color: 'primary',
      width: 300,
    },
  }),
  created() {
    let vm = this;
    vm.$forceUpdate();
  },
  methods: {
    afterselection(item) {
      console.log(item);
      this.$nextTick(() => {
        this.selected = null;
      });
    },

    open(item) {
      this.dialog = true;
      this.confirm = false;
      this.input_image = null;
      this.uploadImageUrl = '';

      // ユーザランク情報の設定
      this.get_userRank();

      // 部署情報の設定
      this.get_department();

      // 役職情報の設定
      this.get_position();

      this.userRank = { label: '', value: '' };
      this.departmentName = { label: '', value: '' };
      this.positionName = { label: '', value: '' };

      if (item == null) {
        this.entryFlg = true;
        this.editFlg = false;

        this.userId = null;
        this.loginId = null;
        this.password = null;
        this.entryPassword = '';
        this.entryPasswordRetry = '';
        this.organaizationKey = null;
        this.userFamilyName = null;
        this.userFamilyNameFurigana = null;
        this.userFirstName = null;
        this.userFirstNameFurigana = null;
        this.userName = null;
        this.userNameFurigana = null;
        this.userRank = { label: '', value: '' };
        this.departmentKey = null;
        this.departmentName = { label: '', value: '' };
        this.positionId = null;
        this.positionName = { label: '', value: '' };
        this.showTitle = null;
        this.userAvaterUseEntry = null;
        this.userAvater =
          config.S3_END_POINT +
          config.AVATER_DIRECTORY +
          config.NO_IMAGE_FILE_NAME +
          '?' +
          moment().format('YYYYMMDDHHmmss');
        this.startWorkingAt = moment().format('YYYY-MM-DD');
        this.endWorkingAt = null;
        this.startWorkingAtEntry = null;
        this.endWorkingAt = null;
        this.endWorkingAtEntry = null;
        this.expiration = null;
        this.createdAt = null;
        this.updateAt = null;
      } else {
        this.entryFlg = false;
        this.editFlg = true;

        this.userId = item.USER_ID;
        this.loginId = makeLoginId(item.LOGIN_ID, item.ORGANIZATION_KEY);
        this.password = item.PASSWORD;
        this.entryPassword = item.PASSWORD.substr(0, 10);
        this.entryPasswordRetry = this.entryPassword;
        this.organaizationKey = item.ORGANIZATION_KEY;
        this.userFamilyName = item.USER_FAMILY_NAME;
        this.userFamilyNameFurigana = item.USER_FAMILY_NAME_FURIGANA;
        this.userFirstName = item.USER_FIRST_NAME;
        this.userFirstNameFurigana = item.USER_FIRST_NAME_FURIGANA;
        this.userName = item.USER_NAME;
        this.userNameFurigana = item.USER_NAME_FURIGANA;
        this.userRank.value = item.USER_RANK;
        this.departmentName.value = item.DEPARTMENT_KEY;
        this.positionName.value = item.POSITION_ID;
        this.showTitle = item.SHOW_TITLE;
        var splitUserAvater = item.USER_AVATER.split('?');
        this.userAvater =
          splitUserAvater[0] + '?' + moment().format('YYYYMMDDHHmmss');
        this.userAvaterUseEntry = null;
        this.expiration = config.USE_IN;
        this.createdAt = item.CREATED_AT;
        this.updateAt = item.UPDATED_AT;

        if (item.START_WORKING_AT != null && item.START_WORKING_AT.trim()) {
          // 勤務開始日
          let strartWorkingArray = item.START_WORKING_AT.split(' ～');
          let strartWorkingTemp = strartWorkingArray[0].replace('勤務：', '');
          this.startWorkingAt = strartWorkingTemp.replaceAll('/', '-');

          // 勤務終了日
          if (item.END_WORKING_AT != config.END_WORKING_AT_INIT) {
            this.endWorkingAt = strartWorkingArray[1].replaceAll('/', '-');
          } else {
            this.endWorkingAt = null;
          }
        }

        this.startWorkingAtEntry = null;
        this.endWorkingAtEntry = null;
      }
      //this.options = Object.assign(this.options, options);

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    get_userRank() {
      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      if (userInfo) {
        this.expiration = userInfo.ORGANIZATION_EXPIRATION;
      }
      if (this.expiration == config.EXPIRATION_PURASUNOKI) {
        // プラスの氣
        this.isJinji = false;
      } else {
        // 人事考課
        this.isJinji = true;
      }

      // ローディング画像表示
      this.loading = true;

      // TOP
      var itemTop = {
        label: userInfo.USER_RANK_NAME_1,
        value: config.USER_RANK_TOP,
      };
      this.userRankItems.push(itemTop);
      // M
      var itemM = {
        label: userInfo.USER_RANK_NAME_2,
        value: config.USER_RANK_M,
      };
      this.userRankItems.push(itemM);
      // S
      var itemS = {
        label: userInfo.USER_RANK_NAME_3,
        value: config.USER_RANK_S,
      };
      this.userRankItems.push(itemS);
      // J
      var itemJ = {
        label: userInfo.USER_RANK_NAME_4,
        value: config.USER_RANK_J,
      };
      this.userRankItems.push(itemJ);
      // E
      var itemE = {
        label: userInfo.USER_RANK_NAME_5,
        value: config.USER_RANK_E,
      };
      this.userRankItems.push(itemE);

      // ローディング画像終了
      this.loading = false;
    },
    get_department() {
      // 部署情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      // ローディング画像表示
      this.loading = true;
      let vm = this;

      axios
        .get(
          config.CONNECT_URL +
            '/Encouragements/manage/department/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 部署データ取得
          this.departmentItems.push({ label: '', value: '' });
          vm.items = response.data;
          for (let i = 0; i < vm.items.length; i++) {
            var item = {
              label: vm.items[i].DEPARTMENT_NAME,
              value: vm.items[i].DEPARTMENT_KEY,
            };
            this.departmentItems.push(item);
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },
    get_position() {
      // 役職情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      // ローディング画像表示
      this.loading = true;
      let vm = this;

      axios
        .get(
          config.CONNECT_URL +
            '/Encouragements/manage/position/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 役職データ取得
          vm.items = response.data;
          for (let i = 0; i < vm.items.length; i++) {
            var item = {
              label: vm.items[i].POSITION_NAME,
              value: vm.items[i].POSITION_ID,
            };
            this.positionItems.push(item);
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },
    onImageChange(file) {
      if (file !== undefined && file !== null) {
        if (file.name.lastIndexOf('.') <= 0) {
          return;
        }
        // 拡張子チェック
        if (file.type != 'image/jpeg' && file.type != 'image/png') {
          this.$refs.dialog.open('info', message.MSG_INFO_IMGTYPE_ERROR);
          return;
        }
        // ファイルサイズチェック
        let imgSizeByte = file.size;
        let imgSizeKb = Math.round(imgSizeByte / 1024);
        if (imgSizeKb > 150) {
          // 150KB以上の画像は受け付けない
          this.$refs.dialog.open('info', message.MSG_INFO_IMGSIZE_ERROR);
          return;
        }
        // ファイル読み込み
        const fr = new FileReader();
        fr.readAsDataURL(file);
        fr.addEventListener('load', () => {
          this.uploadImageUrl = fr.result;
        });
      } else {
        this.uploadImageUrl = '';
      }
    },

    erntry_confirm() {
      // 入力チェック
      if (!this.$refs.staff_form.validate()) {
        return;
      }
      // パスワードチェック
      if (this.entryPassword != this.entryPasswordRetry) {
        this.$refs.dialog.open(
          'info',
          'パスワードとパスワード(再)の入力値が違います。\n再度、パスワードをご入力下さい。'
        );
        return;
      }
      // ユーザランクチェック
      if (!this.isJinji) {
        // データ使用区分が「プラスの氣」のときのみチェック
        if (this.userRank.value == null || !this.userRank.value.trim()) {
          this.$refs.dialog.open(
            'info',
            'ユーザランクが選択されていません。ユーザランクを選択して下さい。'
          );
          return;
        }
      }

      // 役職チェック
      if (this.positionName.value == null || !this.positionName.value.trim()) {
        this.$refs.dialog.open(
          'info',
          '役職が選択されていません。役職を選択して下さい。'
        );
        return;
      }
      // 勤務開始日チェック
      let localStartWorkingAtEntry = this.startWorkingAt.replaceAll('-', '/');
      if (!chackDateFormatStr(localStartWorkingAtEntry)) {
        this.$refs.dialog.open(
          'info',
          '勤務開始日が正しい日付ではありません。\n 勤務開始日は西暦で「YYYY-MM-DD」の形式で入力してください。'
        );
        return;
      } else {
        this.startWorkingAt = this.startWorkingAt.replaceAll('/', '-');
      }
      // 勤務終了日チェック
      if (this.endWorkingAt != null && this.endWorkingAt.trim()) {
        let localEndWorkingAtEntry = this.endWorkingAt.replaceAll('-', '/');
        if (!chackDateFormatStr(localEndWorkingAtEntry)) {
          this.$refs.dialog.open(
            'info',
            '勤務終了日が正しい日付ではありません。\n 勤務終了日は西暦で「YYYY-MM-DD」の形式で入力してください。'
          );
          return;
        } else {
          this.endWorkingAt = this.endWorkingAt.replaceAll('/', '-');
        }
      }
      // 確認ダイアログ表示
      this.deleteFlg = false;
      this.loginFlg = false;
      this.confirmMessage =
        this.userFamilyName +
        this.userFirstName +
        'さんのスタッフ情報を登録しますか？';
      this.$refs.confirm.open();
    },
    delete_confirm() {
      // 入力チェック
      if (!this.$refs.staff_form.validate()) {
        // チェックエラー
        return;
      }
      // 確認ダイアログ表示
      this.deleteFlg = true;
      this.loginFlg = false;
      this.confirmMessage =
        this.userName + 'さんのスタッフ情報を削除しますか？';
      this.$refs.confirm.open();
    },
    login_confirm() {
      // 入力チェック
      if (!this.$refs.staff_form.validate()) {
        // チェックエラー
        return;
      }
      // 変数初期化
      this.deleteFlg = false;
      this.loginFlg = true;
      // 確認ダイアログ表示
      this.confirmMessage =
        this.userName + 'さんのHitonobiに代理ログインしますか？';
      this.$refs.confirm.open();
    },
    editStaffInfo() {
      // セッションチェック
      let userInfo = getSessionStorageItem();
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }
      if (this.deleteFlg) {
        // 削除処理
        this.deleteStaffInfoRequest();
      } else {
        if (this.loginFlg) {
          // 代理ログイン処理
          this.proxyLoginRequest();
        } else {
          // 登録処理
          this.editStaffInfoRequest();
        }
      }
    },
    proxyLoginRequest() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      //----- ログイン認証リクエストPOST
      axios
        .post(config.CONNECT_URL + '/login', {
          ORGANIZATION_KEY: userInfo.ORGANIZATION_KEY, // 組織キー
          LOGIN_ID: this.loginId, // ログインID
          PASSWORD: this.password, // パスワード(暗号化)
        })
        .then((response) => {
          // Output
          this.results = response.data;
          if (this.results.length == 0) {
            // ユーザ情報取得不可
            let warnStr = message.MSG_WARN_LOGIN_ERROR;
            this.password = '';
            this.$refs.dialog.open('warning', warnStr);
          } else if (
            this.results[0].ORGANIZATION_EXPIRATION !=
              config.EXPIRATION_PURASUNOKI &&
            this.results[0].USER_RANK != config.USER_RANK_OWNER &&
            this.results[0].USER_RANK != config.USER_RANK_SYSOP &&
            this.results[0].USER_RANK != config.USER_RANK_TOP &&
            this.results[0].HAS_USER_GRADE == config.VALID_FLAG_OFF
          ) {
            // スタッフ等級設定不可
            let warnStr =
              '等級設定が行われていません。\n' +
              ' 管理者に等級設定を行って頂いた後、再度、ログインをお願いします。';
            this.$refs.dialog.open('warning', warnStr);
          } else {
            // sessionStorageにユーザ情報を保存
            var ret = setSessionStorageItem(
              this.results[0].USER_ID,
              this.results[0].SESSION_ID,
              this.password,
              userInfo.ORGANIZATION_KEY,
              this.results[0].ORGANIZATION_NAME,
              this.results[0].INITIAL_PASSWORD,
              this.results[0].COMMENT_MIN_STRING,
              this.results[0].USER_RANK_NAME_1,
              this.results[0].USER_RANK_NAME_2,
              this.results[0].USER_RANK_NAME_3,
              this.results[0].USER_RANK_NAME_4,
              this.results[0].USER_RANK_NAME_5,
              this.results[0].END_OPERATING_DATE,
              this.results[0].ORGANIZATION_EXPIRATION,
              this.results[0].USER_NAME,
              this.results[0].USER_NAME_FURIGANA,
              this.results[0].USER_RANK,
              this.results[0].POSITION_NAME,
              this.results[0].USER_AVATER,
              this.results[0].START_WORKING_AT,
              this.results[0].DEPARTMENT_KEY,
              this.results[0].DEPARTMENT_NAME
            );

            if (ret) {
              // ##### 代理ログイン セッションストレージの値を設定
              sessionStorage.setItem(
                config.SESSION_PROXY_LOGIN_NAME,
                config.PROXY_LOGIN_TRUE
              );

              // ##### sessionStorageへの保存成功
              if (this.password == this.results[0].INITIAL_PASSWORD) {
                // 初期パスワードの場合、確認ダイアログ表示して終了
                this.confirmMessage =
                  '初期パスワードが設定されています。\n ' +
                  this.userName +
                  'さんのパスワードを変更後に代理ログインを実施してください。';
                //this.$refs.confirm.open();
                this.$refs.dialog.open('info', this.confirmMessage);
              } else if (this.results[0].USER_RANK == config.USER_RANK_OWNER) {
                // オーナー画面遷移処理
                this.$router.push({ name: 'OwnerTop' });
              } else {
                // 運用終了日チェック
                if (
                  this.results[0].END_OPERATING_DATE !=
                  config.END_OPERATING_DATE
                ) {
                  // 現在日時の取得
                  let dtNow = moment().format('YYYY-MM-DD');
                  // 運用終了日の取得
                  let strEndOperatingDate = makeDateFormatStr(
                    this.results[0].END_OPERATING_DATE,
                    '-',
                    '-',
                    ''
                  );
                  // 現在日付 >= 運用終了日の場合、ログアウト
                  if (
                    makeDateTimeStr('E', dtNow) >
                    makeDateTimeStr('S', strEndOperatingDate)
                  ) {
                    // 確認ダイアログ表示
                    this.$refs.dialog.open(
                      'warning',
                      message.MSG_WARN_LOGIN_CLOSING
                    );
                  } else {
                    // プラスの氣画面遷移処理
                    this.$router.push({ name: 'Top' });
                  }
                } else {
                  // プラスの氣画面遷移処理
                  this.$router.push({ name: 'Top' });
                }
              }
            } else {
              // ##### sessionStorageへの保存失敗
              // ログインエラー画面遷移
              this.$router.push({ name: 'LoginError' });
            }
          }
        })
        .catch((error) => {
          let errStr = '';
          // エラーメッセージ表示
          errStr = message.MSG_ERROR_SYTEM + error;
          this.$refs.dialog.open('error', errStr);
        })
        .finally(() => {
          // ローディング画像終了
          this.loading = false;
        });
    },
    editStaffInfoRequest() {
      // ローディング画像表示
      this.loading = false;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      // ユーザ情報作成
      if (this.entryFlg) {
        // 新規登録
        this.userId =
          userInfo.ORGANIZATION_KEY + moment().format('YYYYMMDDHHmmss');
        this.createdAt = moment().format('YYYYMMDDHHmmss');
        this.password = encrypt256(this.entryPassword);

        if (this.isJinji) {
          // データ使用区分が「プラスの氣」以外の場合
          if (this.userRank.value == null || !this.userRank.value) {
            this.userRank.value = config.USER_RANK_E;
          }
        }
      } else {
        // 更新
        if (this.password != null && this.password.trim()) {
          let originalPassword = this.password.substr(0, 10);
          // パスワード設定
          if (originalPassword != this.entryPassword) {
            this.password = encrypt256(this.entryPassword);
          }
        } else {
          this.password = encrypt256(this.entryPassword);
        }
      }
      // 共通
      this.loginId = userInfo.ORGANIZATION_KEY + this.loginId;

      this.organaizationKey = userInfo.ORGANIZATION_KEY;
      this.userName = this.userFamilyName + this.userFirstName;
      this.userNameFurigana =
        this.userFamilyNameFurigana + this.userFirstNameFurigana;
      this.showTitle =
        "<span class='text--primary'>" + this.userName + '</span> ';

      let useImageFlg = true;
      if (this.userAvater != null) {
        let result = this.userAvater.indexOf(config.NO_IMAGE_FILE_NAME);
        if (result != -1) {
          useImageFlg = false;
        }
      }
      this.userAvaterUseEntry = this.userId + '.jpg';

      this.startWorkingAtEntry = this.startWorkingAt.replaceAll('-', '');
      if (this.endWorkingAt != null && this.endWorkingAt.trim()) {
        this.endWorkingAtEntry = this.endWorkingAt.replaceAll('-', '');
      } else {
        this.endWorkingAtEntry = config.END_WORKING_AT_INIT;
      }
      if (this.entryFlg) {
        this.expiration = config.USE_START; // 使用開始
      }

      this.updateAt = moment().format('YYYYMMDDHHmmss');

      //画像読み込み
      let img = document.getElementById('MyImg');
      //Base64の文字列変換
      if (img != null) {
        this.avater = imageToBase64(img, 'image/jpeg');
      } else {
        if (useImageFlg) {
          this.avater = 'USE_IMAGE';
        } else {
          this.avater = '';
        }
      }

      // 役職名設定
      for (let i = 0; i < this.positionItems.length; i++) {
        if (this.positionName.value == this.positionItems[i].value) {
          this.positionName.label = this.positionItems[i].label;
          break;
        }
      }
      // 部署名設定
      for (let i = 0; i < this.departmentItems.length; i++) {
        if (this.departmentName.value == this.departmentItems[i].value) {
          this.departmentName.label = this.departmentItems[i].label;
          break;
        }
      }

      //----- スタッフ情報登録リクエストPOST
      axios
        .post(config.CONNECT_URL + '/Encouragements/manage/member/entry', {
          SESSION_ID: userInfo.SESSION_ID,
          SESSION_USER_ID: userInfo.USER_ID,
          ENTRY_FLG: this.entryFlg,

          USER_ID: this.userId,
          LOGIN_ID: this.loginId,
          PASSWORD: this.password,
          ORGANIZATION_KEY: this.organaizationKey,
          DEPARTMENT_KEY: this.departmentName.value,
          DEPARTMENT_NAME: this.departmentName.label,
          USER_FAMILY_NAME: this.userFamilyName,
          USER_FAMILY_NAME_FURIGANA: this.userFamilyNameFurigana,
          USER_FIRST_NAME: this.userFirstName,
          USER_FIRST_NAME_FURIGANA: this.userFirstNameFurigana,
          USER_NAME: this.userName,
          USER_NAME_FURIGANA: this.userNameFurigana,
          USER_RANK: this.userRank.value,
          POSITION_ID: this.positionName.value,
          POSITION_NAME: this.positionName.label,
          SHOW_TITLE: this.showTitle,
          USER_AVATER: this.userAvaterUseEntry,
          START_WORKING_AT: this.startWorkingAtEntry,
          END_WORKING_AT: this.endWorkingAtEntry,
          EXPIRATION: this.expiration,
          CREATED_AT: this.createdAt,
          UPDATED_AT: this.updateAt,
          USER_AVATER_IMAGE: this.avater,
        })
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            this.userRank = { label: '', value: '' };
            this.positionName = { label: '', value: '' };

            if (this.isJinji && this.entryFlg) {
              msgStr =
                this.userName + message.MSG_INFO_STAFF_ENTRY_COMPLETE_JINJI;
            } else {
              msgStr = this.userName + message.MSG_INFO_STAFF_ENTRY_COMPLETE;
            }

            // 目標ユーザー情報更新
            this.updateGoalUserInfoRequest();

            this.$refs.dialog.open('info', msgStr);
            this.$emit('edit');
          }

          this.resolve(true);
          this.dialog = false;
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
            this.resolve(true);
            this.dialog = false;
          } else if (error.response.status == 404) {
            this.userAvater =
              config.S3_END_POINT +
              config.AVATER_DIRECTORY +
              config.NO_IMAGE_FILE_NAME +
              '?' +
              moment().format('YYYYMMDDHHmmss');
            errStr = message.MSG_INFO_LOGINID_ALREADY_EXISTS;
            // ログインIDが既に存在している
            this.$refs.dialog.open('info', errStr);
            this.loginId = this.loginId.replace(this.organaizationKey, '');
            this.startWorkingAtEntry = null;
            this.endWorkingAtEntry = null;
            this.$refs.loginId.focus();
            return;
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
            this.resolve(true);
            this.dialog = false;
          }
        });
    },
    updateGoalUserInfoRequest() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      //----- 目標ユーザー情報更新リクエストPOST
      axios
        .post(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/goaluser/update',
          {
            SESSION_ID: userInfo.SESSION_ID,
            SESSION_USER_ID: userInfo.USER_ID,

            USER_ID: this.userId,
            ORGANIZATION_KEY: userInfo.ORGANIZATION_KEY,
          }
        )
        .finally(() => {
          // ローディング画像終了
          this.loading = false;
        });
    },
    deleteStaffInfoRequest() {
      // ローディング画像表示
      this.loading = false;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      // 新規登録モードの場合は処理終了
      if (this.entryFlg) {
        return;
      }

      //----- スタッフ情報削除リクエストPOST
      axios
        .post(config.CONNECT_URL + '/Encouragements/manage/member/delete', {
          SESSION_ID: userInfo.SESSION_ID,
          SESSION_USER_ID: userInfo.USER_ID,

          USER_ID: this.userId,
        })
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr = this.userName + message.MSG_INFO_STAFF_DELETE_COMPLETE;
            this.$refs.dialog.open('info', msgStr);
            this.$emit('edit');
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(true);
      this.dialog = false;
    },
  },
};
</script>
<style>
.inner {
  padding-top: 10px;
  display: flex;
  justify-content: space-evenly;
}
</style>
